<template>
    <div v-if="!hide" >
        <div class="countdown-timer flex-row" :class="{'hide-mobile': hideMobile}">
            <div v-for="card in displayCards" :key="card.title" class="d-flex flex-column align-items-center justify-content-center">
                <div class="count-card">{{ card.value }}</div>
                <div class="sub-heading">{{ card.title }}</div>
            </div>
        </div>
    </div>
</template>
<script setup>
	import { onMounted, ref, defineProps } from 'vue'
    import {
        differenceInMonths,
        differenceInDays,
        differenceInHours,
        differenceInMinutes,
        differenceInSeconds,
        addMonths,
        addDays,
        addHours,
        addMinutes,
    } from 'date-fns'

	const emit = defineEmits('timerEnded')
    const props = defineProps({
            endDate: {
                type: Date
            },
            hideMobile: {
                type: Boolean,
                defalt: false
            }
        })

    let lastUpdatedTime = 0
    const hide = ref(true)
    const months = ref(0)
    const days = ref(0)
    const hours = ref(0)
    const minutes = ref(0)
    const seconds = ref(0)
    const displayCards = ref([])

    onMounted(() => {
        updateTimer()
    })

    function updateTimer() {
        lastUpdatedTime = (new Date()).getTime()
        calculateDateDiffs()
        updateCardstoShow()
        // Once timer is up no need to keep calculating
        if (hide.value) {
            return
        }
        // Get as close as we can to one second for next update
        const currentTime = (new Date()).getTime()
        const timeElapsed = currentTime - lastUpdatedTime
        const nextTick = timeElapsed > 0 ? 1000 - timeElapsed : 0
        setTimeout(updateTimer, nextTick)
    }


    function calculateDateDiffs() {
        const currentDate = new Date()
        const endDate = new Date(props.endDate)

        if (isNaN(endDate.getTime())) {
            hide.value = true
            return 
        }

        if (currentDate >= endDate) {
            hide.value = true
		    emit('timerEnded')
            return 
        }


        hide.value = false
        
        let adjustedDate = currentDate

        months.value = differenceInMonths(endDate, currentDate)
        adjustedDate = addMonths(currentDate, months.value)

        days.value = differenceInDays(endDate, adjustedDate)
        adjustedDate = addDays(adjustedDate, days.value)

        hours.value  = differenceInHours(endDate, adjustedDate)
        adjustedDate = addHours(adjustedDate, hours.value)

        minutes.value = differenceInMinutes(endDate, adjustedDate)
        adjustedDate = addMinutes(adjustedDate, minutes.value)

        seconds.value = differenceInSeconds(endDate, adjustedDate)
    }

    function updateCardstoShow() {
        const out = []
        if (months.value > 0) {
            out.push({
                value: months.value,
                title: months.value == 1 ? 'month' : 'months'
            })
        }

        // If months shows days must be shown also
        if (days.value > 0 || months.value > 0) {
            out.push({
                value: days.value,
                title: days.value == 1 ? 'day' : 'days'
            })
        }

        // In the default case the following will show
        out.push({
            value: hours.value,
            title: hours.value == 1 ? 'hour' : 'hours'
        })

        out.push({
            value: minutes.value,
            title: minutes.value == 1 ? 'minute' : 'minutes'
        })

        out.push({
            value: seconds.value,
            title: seconds.value == 1 ? 'second' : 'seconds'
        })

        displayCards.value = out.slice(0, 3)
    }

</script>
<style lang="scss">
    .countdown-timer {
        gap: 4px;
        display: flex;

        @media screen and (max-width: 767px) {
            &.hide-mobile {
                display: none;
            }
        }

        .count-card {
            box-sizing: border-box;
            display: flex;
            width: 35px;
            height: 28px;
            padding: 10px 16px 12px 16px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            flex-shrink: 0;
            border-radius: 8px;
            border: 1px solid var(--Stan-Gradient, #6355FF);
            background: #FEFEFE;

            color: var(--Text-Dark);
            font-family: "Plus Jakarta Sans";
            font-size: 16px;
            font-style: normal;
            font-weight: 800;
            line-height: 100%; /* 16px */
            letter-spacing: -0.16px;
        }

        .sub-heading {
            color: var(--Text-Dark);
            font-family: "Plus Jakarta Sans";
            font-size: 10px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            letter-spacing: -0.2px;
        }
    }
</style>